<template>
  <div class="container">
    <div class="banner">Production & Presentation</div>
    <div class="grid">
      <div class="grid__row" v-for="(row, rowIndex) in array" :key="rowIndex">
        <div
          class="grid__column"
          v-for="(column, columnIndex) in row"
          :key="columnIndex"
        >
          <img class="grid__column__img" :src="column.img" />
          <div class="grid__column__name">{{ column.name }}</div>
        </div>
      </div>
      <div
        v-if="visible.more"
        class="more"
        to="/about-us/brief"
        @click="onMoreClick"
      >
        {{ $t("Read More") }}<i class="iconfont acog-gengduo more__arrow"></i>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from "../components/Footer";
export default {
  data() {
    return {
      visible: {
        more: true
      },
      array: [
        [
          {
            img: require("../assets/productions_1.png"),
            name: "Cats"
          },
          {
            img: require("../assets/productions_2.png"),
            name: "Le Rouge et Noir: L‘Opera Rock"
          },
          {
            img: require("../assets/productions_3.png"),
            name: "Evita"
          },
          {
            img: require("../assets/productions_4.png"),
            name: "Come From Away"
          }
        ],
        [
          {
            img: require("../assets/productions_5.png"),
            name: "Romeo & Juliette."
          },
          {
            img: require("../assets/productions_6.png"),
            name: "RENT"
          },
          {
            img: require("../assets/productions_7.png"),
            name: "Daddy Long Legs"
          },
          {
            img: require("../assets/productions_8.png"),
            name: "Bring My Brother Away"
          }
        ],
        [
          {
            img: require("../assets/productions_9.png"),
            name: "WESTLIFE The Twenty Tour"
          },
          {
            img: require("../assets/productions_10.png"),
            name: "Yoga Lin idol World Tour"
          },
          {
            img: require("../assets/productions_11.png"),
            name: "Ronghao Li IF I WERE YOUNG World Tour Concert"
          },
          {
            img: require("../assets/productions_12.png"),
            name: "Raine Yang YOUTH LIES WITHIN World Tour"
          }
        ],
        [
          {
            img: require("../assets/productions_13.png"),
            name: "Cyndi Wang CYNDILOVES2SING Live Tour"
          },
          {
            img: require("../assets/productions_14.png"),
            name: "The Ultimate Karen Mok Show"
          },
          {
            img: require("../assets/productions_15.png"),
            name: "Priscilla-Ism World Tour"
          },
          {
            img: require("../assets/productions_16.png"),
            name: "Wu Bai And China Blue Rock Star Tour"
          }
        ]
      ]
    };
  },
  methods: {
    onMoreClick() {
      this.visible.more = false;
      this.array = this.array.concat([
        [
          {
            img: require("../assets/productions_17.png"),
            name: "HYDE WORLD TOUR 2019 ASIA"
          },
          {
            img: require("../assets/productions_18.png"),
            name: `w-inds. LIVE TOUR 2019 "FUTURE／PAST"`
          },
          {
            img: require("../assets/productions_19.png"),
            name: "Lil Ghost 2.0 solo concert"
          },
          {
            img: require("../assets/productions_20.png"),
            name: "J.zen's LIVE solo concert"
          }
        ],
        [
          {
            img: require("../assets/productions_21.png"),
            name: "Nel Blu Dipinto Di Blu--Bel Canto Tour"
          },
          {
            img: require("../assets/productions_22.png"),
            name: "Sunrise Tour Sophie Zelmani"
          },
          {
            img: require("../assets/productions_23.png"),
            name: "The Last of the Mohicans-Alexandro Concert"
          },
          {
            img: require("../assets/productions_24.png"),
            name: "Neoclassical pianist Ludovico Einaudi tour"
          }
        ],
        [
          {
            img: require("../assets/productions_25.png"),
            name: "Urban Drama Festival"
          },
          {
            img: require("../assets/productions_26.png"),
            name: "The Eternal Wave"
          },
          {
            img: require("../assets/productions_27.png"),
            name: "The Face of Chiang Kai-shek"
          },
          {
            img: require("../assets/productions_28.png"),
            name: "The Golden Cangue"
          }
        ],
        [
          {
            img: require("../assets/productions_29.png"),
            name: "Peiyu Wang Peking Opera"
          },
          {
            img: require("../assets/productions_30.png"),
            name: "The Drama Night"
          },
          {
            img: require("../assets/productions_31.png"),
            name: "Battlefield"
          },
          {
            img: require("../assets/productions_32.png"),
            name: "C’est Presque Rien"
          }
        ],
        [
          {
            img: require("../assets/productions_33.png"),
            name: "FROZEN 2"
          },
          {
            img: require("../assets/productions_34.png"),
            name: "The Whimsical World of Picasso"
          },
          {
            img: require("../assets/productions_35.png"),
            name: "New Monet Impression：Time Tracking Art"
          },
          {
            img: require("../assets/productions_36.png"),
            name: "The Magic School Bus"
          }
        ],
        [
          {
            img: require("../assets/productions_37.png"),
            name: "CIRQUE DU SOLEIL OVO"
          },
          {
            img: require("../assets/productions_38.png"),
            name: "The Cat Who Wished to Be a Man"
          },
          {
            img: require("../assets/productions_39.png"),
            name: "Piggy Page 2"
          },
          {
            img: require("../assets/productions_40.png"),
            name: "LOC Weekend Theatre"
          }
        ]
      ]);
    }
  },
  components: {
    Footer
  }
};
</script>
<style lang="scss" scoped>
.container {
  .banner {
    height: 312px;
    background-image: url("../assets/productions_banner.png");
    background-position: center;
    background-repeat: no-repeat;
    line-height: 312px;
    font-size: 40px;
    color: #fefefe;
    text-align: center;
  }
  .grid {
    padding-bottom: 72px;
    padding-top: 73px;
    box-sizing: border-box;
    text-align: center;
    &__row {
      text-align: center;
      display: block;
    }
    &__column {
      display: inline-block;
      height: 496px;
      vertical-align: top;
      text-align: center;
      width: 254px;
      &__img{
        border:1px solid rgba(235,235,235,1);
        box-sizing: border-box;
      }
      &__name {
        display: inline-block;
        width: 240px;
        margin-top: 10px;
        height: 20px;
        font-size: 22px;
        font-weight: 400;
        color: rgba(35, 35, 35, 1);
        line-height: 30px;
      }
    }
  }
  .grid__column:not(:first-child) {
    margin-left: 60px;
  }
  .more {
    width: 232px;
    height: 46px;
    border: 1px solid rgba(236, 105, 0, 1);
    border-radius: 23px;
    display: inline-block;
    text-align: center;
    line-height: 46px;
    cursor: pointer;
    color: rgba(236, 105, 0, 1);
    &__arrow {
      margin-left: 2px;
      font-size: 10px;
      vertical-align: middle;
    }
  }
}
</style>